// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".cls-1[data-v-5ebb9ede]{fill:#656565}.cls-2[data-v-5ebb9ede]{fill:#404040}", ""]);
// Exports
module.exports = exports;
